import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import { getFindSatisfactionSurveySettingsKey } from './satisfactionSurveySettings.keys';
import { satisfactionSurveySettingsRepository } from './satisfactionSurveySettings.repository';
import { SatisfactionSurveySettings } from './satisfactionSurveySettings.types';

export const useFindSatisfactionSurveySettings = () =>
  useDataQuery<SatisfactionSurveySettings>({
    queryKey: getFindSatisfactionSurveySettingsKey(),
    queryFn: async () => {
      const response = await satisfactionSurveySettingsRepository.get();

      if (!response.ok || !response.data) {
        throw new Error('Error fetching satisfaction survey settings');
      }

      return response.data;
    },
  });
